// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__quxRd","clinicsSelect":"styles_clinicsSelect__waO8B"};